import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import { PoReceiptCoverage, PoReceiptCoverageRequest, PoReceiptSummary } from '../models/po-receipt/po-receipt';

@Injectable({ providedIn: 'root' })
export class PoReceiptProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/po-receipt';

  /** Would paying these documents take any of their POs past what was received? One call for the batch. */
  public getCoverage(requests: PoReceiptCoverageRequest[]): Observable<ApiResponse<PoReceiptCoverage[]>> {
    return this.httpClient.post<ApiResponse<PoReceiptCoverage[]>>(`${this.baseUrl}/coverage/by-documents`, requests);
  }

  /** What was received against each PO — items, and the receiving documents behind them. One call for all. */
  public getSummaries(purchaseOrderReferences: string[]): Observable<ApiResponse<PoReceiptSummary[]>> {
    return this.httpClient.post<ApiResponse<PoReceiptSummary[]>>(`${this.baseUrl}/summary/by-purchase-orders`, purchaseOrderReferences);
  }
}
